import { api } from './api_helper';

/**
 * Update user question and answer status (approve/incorrect)
 * @param qnaId The ID of the question and answer to update
 * @param isApproved Whether the answer is approved or not
 * @returns A promise that resolves when the update is complete
 */
export const updateUserQNAStatus = async (qnaId: string, isApproved: boolean): Promise<void> => {
  await api.put('/assessments/user/marked/QNA', {
    qnaId,
    status: isApproved ? 'approved' : 'incorrect',
  });
};

/**
 * Get the video URL for a skill assessment question
 * @param qnaId The ID of the question and answer
 * @returns A promise that resolves to the video URL
 */
export const getSkillAssessmentVideo = async (qnaId: string): Promise<string> => {
  // First get the download URL
  const downloadResponse = await api.get(`/webrtc/download?user_assessment_qna_id=${qnaId}`);
  // Then get the actual video URL
  const videoResponse = await api.get('/get/video', {
    params: {
      user_assessment_qna_id: qnaId,
    },
  });
  return videoResponse.data.url;
};

/**
 * Delete users from an assessment
 * @param assessmentId The ID of the assessment
 * @param assessmentUserIds The IDs of the assessment users to delete
 * @returns A promise that resolves when the deletion is complete
 */
export const deleteAssessmentUser = async (assessmentId: string, assessmentUserIds: string[]): Promise<void> => {
  await api.delete(`/assessments/${assessmentId}/user`, {
    data: {
      assessmentUserIds,
    },
  });
};
